import { render } from "./Safety.vue?vue&type=template&id=2c50dbed&scoped=true"
import script from "./Safety.vue?vue&type=script&lang=js"
export * from "./Safety.vue?vue&type=script&lang=js"

import "./Safety.vue?vue&type=style&index=0&id=2c50dbed&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c50dbed"]])

export default __exports__